import { useSelector } from "react-redux";

const getHomePageUrl = () => {
  const layout = useSelector((state) => state.layout);

  return [layout.DEFAULT_LANDING_PAGE];
};

export default getHomePageUrl;
